<template>
    <InputGenerator v-if="hydrated"
                    :name="fieldName"
                    :inputData="dataArray"
                    :namespace="namespace"
                    :key="namespace"
                    :fieldsInGroup="parseInt(fieldOptions.fields_in_group)"
                    :groupInline="fieldOptions.groupInline"
                    :groupNumbered="fieldOptions.groupNumbered"
                    :groupFields="fieldOptions.group.fields"
    ></InputGenerator>
</template>

<script>
import PopulationBoilerplate from '@/views/Admin/Config/Population/Fields/PopulationBoilerplate';
import PopulationGroupBoilerplate from '@/views/Admin/Config/Population/Fields/Groups/PopulationGroupBoilerplate';
import InputGenerator from '@/views/Common/Input/Groups/InputGenerator';

export default {
    mixins: [ PopulationBoilerplate, PopulationGroupBoilerplate ],
    components: { InputGenerator },
};
</script>
